import { memo, useState, useEffect, ChangeEvent, Dispatch, SetStateAction, FC } from 'react'
import { Select, Skeleton } from '@chakra-ui/react'

import { ImpactModule, VisualizationKeyString } from 'types'
import readVisualizationsForFilter from './services/calls/visualizations/readVisualizations'
import { getStringInPhraseFormat } from 'utils/transforms/string'

type Props = {
  MODULE: ImpactModule
  filterKind?: string
  localStorageKey: string
  visualization: VisualizationKeyString
  setVisualization: Dispatch<SetStateAction<VisualizationKeyString>>
}

const VisualizationsSelect: FC<Props> = ({ MODULE, filterKind, localStorageKey, visualization, setVisualization }) => {
  const [visualizations, setVisualizations] = useState<VisualizationKeyString[]>([])
  const [loadingVisualizations, setLoadingVisualizations] = useState(true)

  function getSelectedVisualizationById(visualizationId: string): VisualizationKeyString {
    const [selectedVisualization] = visualizations.filter(({ id }) => {
      if (id === visualizationId) return true
      return false
    })
    return selectedVisualization || {}
  }

  function handleOnChangeSelect(event: ChangeEvent<HTMLSelectElement>) {
    const selectedId = event.target.value
    localStorage.setItem(localStorageKey, selectedId)
    const visualization = getSelectedVisualizationById(selectedId)
    setVisualization(visualization)
  }

  async function loadCitizensVisualizations() {
    setLoadingVisualizations(true)
    const response = await readVisualizationsForFilter({
      moduleName: MODULE?.NAME,
      filters: {
        filter: { kind: `${MODULE.NAME}/${filterKind}`, status: 'ACTIVE' },
        pagination: { page: 1, limit: 0 },
      },
    })
    if (response?.header?.success) {
      setVisualizations(response.body.visualization.elements)
    }
    setLoadingVisualizations(false)
  }

  useEffect(() => {
    loadCitizensVisualizations()
  }, [])

  useEffect(() => {
    const visualizationId = localStorage.getItem(localStorageKey)
    if (visualizations.length > 0 && visualizationId) {
      const currentVisualization = getSelectedVisualizationById(visualizationId)
      setVisualization(currentVisualization)
    }
  }, [visualizations])

  return (
    <Skeleton isLoaded={!loadingVisualizations}>
      <Select minWidth="150px" value={visualization.id || ''} onChange={handleOnChangeSelect}>
        <option value="">Padrão</option>
        {visualizations.map(({ name, id }) => (
          <option key={id} value={id}>
            {getStringInPhraseFormat(name)}
          </option>
        ))}
      </Select>
    </Skeleton>
  )
}

export default memo(VisualizationsSelect)
